import * as yup from "yup";

export const priceIdentifierList = [
    {
        priceldentifier_id: 3,
        description: "Scheme",
        key: "SCHEME",
    },
    {
        priceldentifier_id: 1,
        description: "Discount Percent",
        key: "DISCOUNT_PERCENT",
    },
    {
        priceldentifier_id: 2,
        description: "Discount Amount",
        key: "DISCOUNT_AMOUNT",
    },
];

export const schema = yup.object({
    itemCode: yup.string().required("Item Code is required"),
    itemName: yup.string().required("Item Name is required"),
    itemPrice: yup.object().required("Item Price is required"),
    mrp: yup.number().required("MRP is required"),
    price: yup.number().required("Price is required"),
    batchNo: yup.string().required("Batch No. is required"),
    // schemeType: yup.object().required("Scheme Type is required"),
    quantity: yup.number().integer().required("Quantity is required"),
    // freeQty: yup.number().integer().default(0),
});

//Schema 2 for unknown order
export const schema2 = yup.object({
    // itemCode: yup.string().required("Item Code is required"),
    itemName: yup.string().required("Item Name is required"),
    itemPrice: yup.object().required("Item Price is required"),
    mrp: yup.number().required("MRP is required"),
    price: yup.number().required("Price is required"),
    batchNo: yup.string().required("Batch No. is required"),
    // schemeType: yup.object().required("Scheme Type is required"),
    quantity: yup.number().integer().required("Quantity is required"),
    // freeQty: yup.number().integer().default(0),
});

